import React from "react";
import LegalLayout, { Section } from "@/pages/LegalLayout";

export default function RefundPolicy() {
  return (
    <LegalLayout
      title="Refund Policy"
      lastUpdated="October 2026"
      testid="refund-page"
    >
      <Section heading="No Refunds">
        <p>
          We do not offer refunds.{" "}
          <span className="text-white">All sales are final.</span>
        </p>
      </Section>
    </LegalLayout>
  );
}
